module.exports = __webpack_public_path__ + "static/media/metamask.0a09318c.png";